import { useState } from "react";
import HomeComponent from "../HomeComponent/HomeComponent";

const LocationComponent = () => {
    const [isLocationEnabled, setIsLocationEnabled] = useState(false);
    const [location, setLocation] = useState(null);
    const [address, setAddress] = useState(null);
    const [error, setError] = useState(null);

    const getLocation = () => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setLocation({ latitude, longitude });

                // Fetch address from OpenStreetMap API
                fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.address) {
                            setAddress(`${data.display_name}`);
                            console.log(data);
                            
                        } else {
                            setAddress("Location not found");
                        }
                    })
                    .catch(() => setAddress("Error fetching address"));
                
                setError(null);
            },
            (err) => {
                setError("Permission denied or error fetching location.");
                setLocation(null);
                setAddress(null);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0,
            }
        );
    };

    const toggleLocation = () => {
        if (isLocationEnabled) {
            setLocation(null);
            setAddress(null);
            setError(null);
        } else {
            getLocation();
        }
        setIsLocationEnabled(!isLocationEnabled);
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h2>Location Services</h2>
            <button onClick={toggleLocation}>
                {isLocationEnabled ? "Turn Off Location" : "Turn On Location"}
            </button>

            {location && (
                <div>
                    <h3>Current Location:</h3>
                    <p>Latitude: {location.latitude}</p>
                    <p>Longitude: {location.longitude}</p>
                    {address ? <p>Address: {address}</p> : <p>Loading address...</p>}
                </div>
            )}

            {error && <p style={{ color: "red" }}>{error}</p>}
            <div>
                <HomeComponent />
            </div>
        </div>
    );
};

export default LocationComponent;
